import FileUploadContainer from "./Containers/FileUploadContainer";
export default FileUploadContainer;
